var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8266 5.16715C10.0466 4.38715 9.02659 3.99381 7.99992 3.99381V7.99381L5.17325 10.8205C6.73325 12.3805 9.26659 12.3805 10.8333 10.8205C12.3933 9.26048 12.3933 6.72715 10.8266 5.16715ZM7.99992 1.32715C4.31992 1.32715 1.33325 4.31381 1.33325 7.99381C1.33325 11.6738 4.31992 14.6605 7.99992 14.6605C11.6799 14.6605 14.6666 11.6738 14.6666 7.99381C14.6666 4.31381 11.6799 1.32715 7.99992 1.32715ZM7.99992 13.3271C5.05325 13.3271 2.66659 10.9405 2.66659 7.99381C2.66659 5.04715 5.05325 2.66048 7.99992 2.66048C10.9466 2.66048 13.3333 5.04715 13.3333 7.99381C13.3333 10.9405 10.9466 13.3271 7.99992 13.3271Z",
    fill: "#298FF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_2085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.64a0a3a77b57b39fc1b73d5c64fab7b9.svg";
export { ForwardRef as ReactComponent };